import { hangUp } from "@/Services/TherapyApi/VideoCalls";

const hangUpVideocall = async (roomId: string): Promise<unknown> => {
  return hangUp(roomId);
};

export default hangUpVideocall;
